import { FC } from "react";
import { useParams } from "react-router-dom";
import { useSingleTenantChallenges } from "../../hooks/useSingleTenantChallenge";
import { Spinner } from "@radix-ui/themes";
import { SubmitScoreGame } from "./SubmitScoreGame.fetcher";

export type SubmitResultsFormProps = {
  value: string;
  image: any;
};

export const SubmitScore: FC<{}> = ({}) => {
  const { slug } = useParams();
  const { data, loading, error } = useSingleTenantChallenges(slug);

  if (loading) {
    return <Spinner />;
  }

  if (error) {
    return <div>Error: {error.message}</div>;
  }

  if (!data) {
    return <div>No data found</div>;
  }

  return <SubmitScoreGame {...data} />;
};
